import React, { useContext, useEffect, useState } from 'react';
import PickUpSettings from './PickUpSettings';
import {
    Box,
    Paper,
    Stack,
    TextField,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Typography,
    InputAdornment,
    Button,
    CircularProgress,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import Delivery from '../../../../delivery/Delivery';
import PropTypes from 'prop-types';
import { RestauInfoContext } from '../../../../home/RestauInfoContext';
import { useStyles } from '../../../../home/useStyles';
//import PropTypes from 'prop-types';

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(2),
    color: theme.palette.text.secondary,
    width: '100%',
    boxSizing: 'border-box', // Include padding in width calculation
    overflow: 'hidden', // Prevent overflow by default
}));

function PickupAndDeliverySettings(props) {
    const { orderType, mode } = props;
    const resauInfoContext = useContext(RestauInfoContext);
    const restauHook = resauInfoContext.restauHook;
    const [saveMessage, setSaveMessage] = React.useState('');
    const [loaded, setLoaded] = React.useState(false);
    const classes = useStyles();
    // State for buffer time fields
    const [bufferTimeUnit, setBufferTimeUnit] = useState('minutes');
    const [bufferFromCurrentTime, setBufferFromCurrentTime] = useState('');
    const [bufferFromStartOfSession, setBufferFromStartOfSession] =
        useState('');

    const convertToMinutes = (value, unit) => {
        if (value === '' || isNaN(value)) return 0;
        if (unit === 'minutes') {
            return value;
        } else if (unit === 'hours') {
            return value * 60;
        } else if (unit === 'days') {
            return value * 60 * 24;
        }
    };

    const convertToUnit = (value, unit) => {
        if (value === '' || isNaN(value)) return 0;
        if (unit === 'minutes') {
            return value;
        } else if (unit === 'hours') {
            return value / 60;
        } else if (unit === 'days') {
            return value / (60 * 24);
        }
    };

    const saveBufferSettings = async () => {
        //validations
        if (
            !bufferTimeUnit ||
            !bufferFromCurrentTime ||
            !bufferFromStartOfSession
        ) {
            alert('Buffer Time Settings fields cannot be empty');
            return;
        }

        // Logic to save buffer settings
        setLoaded(true);
        let bufferFromCurrentTimeInMins = convertToMinutes(
            bufferFromCurrentTime,
            bufferTimeUnit
        );
        const database = window.customerApp.database();
        let deliveryConfsetting = {};
        //setDeliveryConfig(deliveryConf);
        deliveryConfsetting[
            'menus/' +
                restauHook.restauId +
                '/details/cateringConfig/bufferTimeSettings'
        ] = {
            bufferFromCurrentTimeInMins,
            bufferFromStartOfSession,
            bufferTimeUnit,
        };

        await database
            .ref()
            .update(deliveryConfsetting)
            .then(function () {
                setSaveMessage('Buffer settings successfully updated');
                setLoaded(false);
            })
            .catch(function (error) {
                alert('Error while saving please try again');
                //Need to pop error someways
                console.log(error);
                setLoaded(false);
                return;
            });
    };

    // Fetch existing buffer settings from database on component mount
    const fetchBufferSettings = async () => {
        const database = window.customerApp.database();
        const bufferSettingsRef = database.ref(
            'menus/' +
                restauHook.restauId +
                '/details/cateringConfig/bufferTimeSettings'
        );
        const snapshot = await bufferSettingsRef.once('value');
        const data = snapshot.val();
        if (data) {
            setBufferTimeUnit(data.bufferTimeUnit || 'minutes');
            setBufferFromCurrentTime(
                convertToUnit(
                    data.bufferFromCurrentTimeInMins || '',
                    data.bufferTimeUnit
                ) || ''
            );
            setBufferFromStartOfSession(data.bufferFromStartOfSession || '');
        }
    };

    useEffect(() => {
        fetchBufferSettings();
    }, [restauHook.restauId]);

    return (
        <Stack
            sx={{ width: '100%', overflow: 'hidden', p: { xs: 0, sm: 2 } }}
            spacing={2}
        >
            <Item
                elevation={0}
                sx={{ overflow: 'hidden', p: { xs: 0, sm: 2 } }}
            >
                <Box sx={{ width: '100%', boxSizing: 'border-box' }}>
                    {/* <Typography variant="h6" gutterBottom>
                        Buffer Time Settings
                    </Typography> */}
                    <h2>Buffer Time Settings</h2>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: { xs: 'column', sm: 'row' },
                            gap: { xs: 2, sm: 3 },
                            width: '100%',
                        }}
                    >
                        {/* Buffer From Current Time */}
                        <Box>
                            <Typography variant="subtitle2" gutterBottom>
                                Buffer From Current Time
                            </Typography>
                            <Stack
                                direction="row"
                                spacing={1}
                                sx={{ width: 'auto' }}
                            >
                                <FormControl sx={{ width: 110 }}>
                                    <InputLabel id="buffer-time-unit-label">
                                        Unit
                                    </InputLabel>
                                    <Select
                                        labelId="buffer-time-unit-label"
                                        value={bufferTimeUnit}
                                        label="Unit"
                                        onChange={(e) => {
                                            setSaveMessage('');
                                            setBufferTimeUnit(e.target.value);
                                        }}
                                        size="medium"
                                    >
                                        <MenuItem value="days">Days</MenuItem>
                                        <MenuItem value="hours">Hours</MenuItem>
                                        <MenuItem value="minutes">
                                            Minutes
                                        </MenuItem>
                                    </Select>
                                </FormControl>
                                <TextField
                                    label="Value"
                                    type="number"
                                    value={bufferFromCurrentTime}
                                    onChange={(e) => {
                                        setSaveMessage('');
                                        setBufferFromCurrentTime(
                                            e.target.value
                                        );
                                    }}
                                    InputProps={{
                                        inputProps: { min: 0 },
                                    }}
                                    sx={{ width: 150 }}
                                />
                            </Stack>
                        </Box>
                        {/* Buffer From Start of Session */}
                        <Box>
                            <Typography variant="subtitle2" gutterBottom>
                                Buffer From Start of Session
                            </Typography>
                            <TextField
                                label="Minutes"
                                type="number"
                                value={bufferFromStartOfSession}
                                onChange={(e) => {
                                    setSaveMessage('');
                                    setBufferFromStartOfSession(e.target.value);
                                }}
                                InputProps={{
                                    inputProps: { min: 0 },
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            mins
                                        </InputAdornment>
                                    ),
                                }}
                                helperText="Enter value in minutes only"
                                sx={{ width: 200 }}
                            />
                        </Box>
                        <Box>
                            <div style={{ maxWidth: 350, marginTop: '40px' }}>
                                <Button
                                    size="medium"
                                    variant="contained"
                                    color="primary"
                                    onClick={saveBufferSettings}
                                    style={{ width: 'auto' }}
                                    disabled={loaded}
                                >
                                    Update
                                    {loaded && (
                                        <CircularProgress
                                            size={24}
                                            style={{ color: 'black' }}
                                        />
                                    )}
                                </Button>
                            </div>
                            <div
                                style={{
                                    marginTop: '5px',
                                    color: 'green',
                                }}
                            >
                                {saveMessage}
                            </div>
                        </Box>
                    </Box>
                </Box>
            </Item>

            <Item
                elevation={0}
                sx={{ overflow: 'hidden', p: { xs: 0, sm: 2 } }}
            >
                <Stack
                    direction={{ xs: 'column', sm: 'row' }}
                    spacing={{ xs: 1, sm: 2, md: 3 }}
                    sx={{
                        width: '100%',
                        overflow: 'hidden',
                    }}
                >
                    <Item
                        elevation={0}
                        sx={{
                            flex: { xs: '1 1 100%', sm: '0 0 60%' },
                            width: { xs: '100%', sm: 'auto' },
                            minWidth: 0,
                            overflow: 'auto',
                            m: 0,
                            p: 0,
                        }}
                    >
                        <Delivery orderType={orderType} />
                    </Item>
                    <Item
                        elevation={0}
                        sx={{
                            flex: { xs: '1 1 100%', sm: '0 0 40%' },
                            width: { xs: '100%', sm: 'auto' },
                            minWidth: 0,
                            overflow: 'auto',
                            m: 0,
                            p: 0,
                        }}
                    >
                        <PickUpSettings orderType={orderType} mode="pickup" />
                    </Item>
                </Stack>
            </Item>
        </Stack>
    );
}

PickupAndDeliverySettings.propTypes = {
    orderType: PropTypes.string,
    mode: PropTypes.string,
};

export default PickupAndDeliverySettings;
